export const DEFAULT_QUERY_STALE_TIME = 1000 * 60 * 5; // 5 minutes
export const LIMIT_PAGINATION = 20;
